import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {NavigationStart, Router} from "@angular/router";

export interface ToastMessage {
  headline: string;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
  allowHtml?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toastSubject = new BehaviorSubject<ToastMessage | null>(null);
  toast$ = this.toastSubject.asObservable();

  private hideTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.clear();
      }
    });
  }

  show(
    headline: string,
    message: string,
    type: ToastMessage['type'] = 'info',
    options?: { allowHtml?: boolean; durationMs?: number },
  ) {
    this.clearHideTimer();
    this.toastSubject.next({
      headline,
      message,
      type,
      allowHtml: options?.allowHtml ?? false,
    });

    // Auto-dismiss after the given duration (snackbar behaviour).
    if (options?.durationMs) {
      this.hideTimer = setTimeout(() => this.clear(), options.durationMs);
    }
  }

  clear() {
    this.clearHideTimer();
    this.toastSubject.next(null);
  }

  private clearHideTimer() {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }
}
